import { useModuleContext } from "src/lib/context/module-context";
import { useTranslation } from "react-i18next";
import "./styles.css";

export const ProgressBar = () => {
  const { totalSteps, currentStep, currentModuleNumber } = useModuleContext();
  const { t } = useTranslation(["common"]);
  const topBarText = (() => {
    switch (currentModuleNumber) {
      case 4:
        return t("common:onboarding_info");
      case 5:
        return "";
      default:
        return t("common:info");
    }
  })();

  return (
    <div className="progress-bar-container">
      <div className="flex items-center progress-wrapper">
        <div className="progress-bar">
          {Array.from({ length: totalSteps }).map((_, index) => (
            <div
              key={index}
              className={`progress-segment ${index === 0 ? "first" : ""} ${
                index === totalSteps - 1 ? "last" : ""
              } ${index < currentStep ? "filled" : ""}`}
            />
          ))}
        </div>
      </div>
      <p className="top-bar-title center" aria-label={topBarText}>
        {topBarText}
      </p>
    </div>
  );
};
